import React, { useState } from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const DeadlineCalendar = ({ projects, onOpenProject }) => {
  const [base, setBase] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const byDate = {};
  projects.forEach(p => { if (p.due_date) (byDate[p.due_date] = byDate[p.due_date] || []).push(p); });
  const year = base.getFullYear(), month = base.getMonth();
  const first = (new Date(year, month, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const cells = [...Array(first).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  const iso = (day) => `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  return (
    <div className="border border-slate-200 bg-white rounded-md p-4" data-testid="rfp-deadline-calendar">
      <div className="flex items-center justify-between mb-3">
        <Button size="sm" variant="ghost" className="h-7 px-2" onClick={() => setBase(new Date(year, month - 1, 1))}
          data-testid="rfp-cal-prev"><ChevronLeft className="w-4 h-4" /></Button>
        <p className="text-sm font-bold text-[#0F2040]">{base.toLocaleDateString(undefined, { month: 'long', year: 'numeric' })}</p>
        <Button size="sm" variant="ghost" className="h-7 px-2" onClick={() => setBase(new Date(year, month + 1, 1))}
          data-testid="rfp-cal-next"><ChevronRight className="w-4 h-4" /></Button>
      </div>
      <div className="grid grid-cols-7 gap-1">
        {DAYS.map(d => <p key={d} className="text-[9px] font-semibold text-slate-400 text-center uppercase">{d}</p>)}
        {cells.map((day, i) => {
          if (!day) return <div key={`e${i}`} />;
          const due = byDate[iso(day)] || [];
          const past = new Date(year, month, day) < today;
          return (
            <div key={day} className={`min-h-[52px] border rounded-md p-1 ${due.length ? 'border-[#4ABFCF]/50 bg-[#4ABFCF]/5' : 'border-slate-100'}`}>
              <p className={`text-[9px] font-medium ${past ? 'text-slate-400' : 'text-slate-600'}`}>{day}</p>
              {due.map(p => (
                <button key={p.id} onClick={() => onOpenProject(p.id)}
                  className={`block w-full text-left text-[9px] font-semibold truncate rounded px-1 py-0.5 mb-0.5
                    ${p.outcome === 'won' ? 'bg-emerald-100 text-emerald-800' : p.outcome === 'lost' ? 'bg-rose-100 text-rose-700'
                      : past ? 'bg-rose-50 text-rose-700' : 'bg-[#0F2040] text-white'}`}
                  title={`${p.name}${p.open_questions ? ` — ${p.open_questions} open question${p.open_questions === 1 ? '' : 's'}` : ''}`}
                  data-testid={`rfp-cal-item-${p.id}`}>
                  {p.name}{p.open_questions > 0 && <span className="opacity-70"> · {p.open_questions}</span>}
                </button>
              ))}
            </div>
          );
        })}
      </div>
      {!projects.some(p => p.due_date) ? (
        <p className="text-xs text-slate-400 text-center pt-3" data-testid="rfp-cal-empty">No due dates set yet — add one from any project header.</p>
      ) : projects.some(p => p.due_date && p.open_questions > 0) && (
        <p className="text-[9px] text-slate-400 pt-2" data-testid="rfp-cal-workload-hint">Numbers on each RFP show open questions still to answer — spot the crunch weeks.</p>
      )}
    </div>
  );
};
